import { render, staticRenderFns } from "./MassSpectrometerViz.vue?vue&type=template&id=b48060c0&scoped=true"
import script from "./MassSpectrometerViz.vue?vue&type=script&lang=js"
export * from "./MassSpectrometerViz.vue?vue&type=script&lang=js"
import style0 from "./MassSpectrometerViz.vue?vue&type=style&index=0&id=b48060c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48060c0",
  null
  
)

export default component.exports